import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { RETAIL_ONLY_CART } from 'constants/cartTypes';
import { CHECKOUT_STEP_MAP, PAYMENT_STEP } from 'constants/checkoutFlow';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import RightArrow from 'components/checkout/caap/RightArrow';
import { getPaymentTypeIcon } from 'components/checkout/CheckoutUtils';
import { isCreditCardExpired } from 'helpers/MyAccountUtils';
import css from 'styles/components/checkout/caap/payment/payment.scss';

const Payment = (params, { testId }) => {
  const {
    cartType,
    doesPurchaseRequireCC,
    eligibleBalances = {},
    onChangePaymentClick,
    paymentMethod,
    purchaseId,
    usePromoBalance
  } = params;

  const isExpired = paymentMethod ? isCreditCardExpired(paymentMethod) : false;

  return (
    <div>
      <Row desktopOnly={true}>
        <RowSpan span="4">
          <div className={css.inactiveTitleBar}>
            <div className={css.titleWrapper}>
              <div className={css.stepIndex}>
                <h3>2</h3>
              </div>
              <h4 className={css.title}>Payment method</h4>
            </div>
          </div>
        </RowSpan>
        <RowSpan span="7">
          { doesPurchaseRequireCC || !usePromoBalance
            ? makePayment({ paymentMethod, isExpired }, { testId })
            : null
          }
          { usePromoBalance && eligibleBalances.combinedDiscountBalance
            ? makePromoDescriptions(cartType, eligibleBalances)
            : null
          }
        </RowSpan>
        <RowSpan span="1">
          <div className={css.changeSectionContainer} data-test-id={testId('changePaymentMethod')}>
            <Link
              onClick={onChangePaymentClick}
              to={`${CHECKOUT_STEP_MAP[PAYMENT_STEP]}?referrer=spc&pid=${purchaseId}`}>Change</Link>
          </div>
        </RowSpan>
      </Row>

      <Row mobileOnly={true} data-test-id={testId('paymentMethodBlock')}>
        <Link onClick={onChangePaymentClick} to={`${CHECKOUT_STEP_MAP[PAYMENT_STEP]}?referrer=spc&pid=${purchaseId}`} data-test-id={testId('changePaymentMethod')}>
          <Row mobileOnly={true}>
            <RowSpan span="10">
              <h4>Payment method</h4>
              { doesPurchaseRequireCC || !usePromoBalance
                ? makePayment({ paymentMethod, isExpired }, { testId })
                : null
              }
              { usePromoBalance && eligibleBalances.combinedDiscountBalance
                ? makePromoDescriptions(cartType, eligibleBalances)
                : null
              }
            </RowSpan>
            <RowSpan span="2">
              <RightArrow data-test-id={testId('paymentChevron')} />
            </RowSpan>
          </Row>
        </Link>
      </Row>
    </div>
  );
};

Payment.contextTypes = {
  testId: PropTypes.func
};

const makePayment = ({ isExpired, paymentMethod }, { testId }) => {
  if (!paymentMethod) {
    return null;
  }

  const paymentIconStyles = cn(
    {
      [css.bordered]: paymentMethod.ccIssuer === 'Visa' || paymentMethod.ccIssuer === 'MasterCard'
    }
  );

  return (
    <div data-test-id={testId('paymentMethod')}>
      <span className={paymentIconStyles}>{getPaymentTypeIcon(paymentMethod.ccIssuer)} ending in {paymentMethod.tail}</span>
      { isExpired
        ? <span className={css.expired} data-test-id={testId('expirationInfo')}>Exp: {paymentMethod.expirationMonth}/{paymentMethod.expirationYear}</span>
        : null
      }
    </div>
  );
};

const makePromoDescriptions = (cartType, eligibleBalances) => {
  const { couponBalance, gcBalance } = eligibleBalances;
  return (
    <div>
      { couponBalance ? <div>Promotional Code</div> : null }
      { gcBalance && cartType === RETAIL_ONLY_CART ? <div>Gift Card</div> : null }
    </div>
  );
};

export default Payment;
